
 
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Observable, pipe, throwError} from 'rxjs';
 

import {map, tap} from 'rxjs/operators';
import decode from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {AppSettings} from '../settings';
 
@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  private message: string; 

  constructor(private _router: Router,private http: HttpClient ) {

    
   }



   send_invite_now(obj:any):Observable<any>{
       
    
    
    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,
            
          })
        };
       
      let api_url =AppSettings.API_ENDPOINT+'newsletter.php';
    
       return this.http.post<any>(api_url,obj.details ,httpOptions);



      }catch(err){
  
        // notify system api error 
        this._router.navigate(['/login']);

      
  
      }

    

  }  
 


  add_update_newsltter_to_calender(obj:any):Observable<any>{
       
    
    
    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,
            
          })
        };
       
      let api_url =AppSettings.API_ENDPOINT+'calendar.php';
    
       return this.http.post<any>(api_url,obj.details ,httpOptions);



      }catch(err){
  
        // notify system api error 
        this._router.navigate(['/login']);

      
  
      }

    

  } 


   
  list_newsltters_from_calender(obj:any):Observable<any>{
       
    
    
    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,
            
          })
        };
       
       let api_url =AppSettings.API_ENDPOINT+'calendar.php';
    
       return this.http.post<any>(api_url,obj.details,httpOptions);



      }catch(err){
  
        // notify system api error 
        this._router.navigate(['/login']);

      
  
      }

    

  } 
}